import { FC, PropsWithChildren } from "react";

export const DrawerChildren: FC<PropsWithChildren> = ({ children }) => {
  if (!children) { return null; }
  return (
    <div data-component="DrawerChildren" className="flex flex-1 flex-col gap-4 overflow-y-auto">
      { children }
    </div>
  );
};
